import React from 'react';
import { Message } from '@naf/input';
import * as S from './ConsentSelect.style';

interface ConsentSelectProps {
  consented: boolean;
  undetermined?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  onSelectNo?: () => void;
  onSelectYes?: () => void;
}

export const ConsentSelect = ({
  consented,
  undetermined = false,
  errorMessage,
  disabled = false,
  onSelectNo,
  onSelectYes,
}: ConsentSelectProps) => (
  <S.FieldWrapper>
    <S.RadioButtonGroup>
      <S.StyledRadioButton
        onChange={() => {
          if (onSelectYes) {
            onSelectYes();
          }
        }}
        variant={typeof errorMessage !== 'undefined' ? 'error' : 'standard'}
        checked={!undetermined && consented}
        outline={false}
        label="Ja"
        isDisabled={disabled}
      />
      <S.StyledRadioButton
        onChange={() => {
          if (onSelectNo) {
            onSelectNo();
          }
        }}
        variant={typeof errorMessage !== 'undefined' ? 'error' : 'standard'}
        checked={!undetermined && !consented}
        outline={false}
        label="Nei"
        isDisabled={disabled}
      />
    </S.RadioButtonGroup>
    {errorMessage && <Message error>{errorMessage}</Message>}
  </S.FieldWrapper>
);
